import Vue from 'vue'
import App from './App.vue'
import router from "./router";

// // 查看手机浏览器的控制台日志的办法
// import VConsole from 'vconsole';
// new VConsole(); // 自动在移动端显示控制台

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import ClickOutside from './static/js/click-outside';
Vue.directive('click-outside', ClickOutside);

Vue.use(ElementUI);

// 全局样式
import "./static/css/style.min.css";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// 判断是否是iOS
const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
if (!isIOS) {
    import('@/assets/google/fonts.css');
    import('@/assets/google/fontsico.css');
    import('@/static/css/google.css');
    import('@/static/css/googledatasafety.css');
    import('@/static/css/repeater_help_panel.css');
} else {
    import('@/assets/fonts/fonts.css');
}

import { loadUrlList } from './utils/loadConfig';

Vue.config.productionTip = false;

// 启动前加载配置
loadUrlList().then(commentJson => {
    // 注入为全局属性
    Vue.prototype.$commentJson = commentJson;

    new Vue({
        router,
        render: h => h(App),
    }).$mount('#app');
}).catch(err => {
    console.error("配置加载失败：", err);
});
